import { DEMO_CALCULATOR_STEP } from 'config/constants'
import {
  DEMO_STEP_DELAY,
  DEMO_STEP_PLAYBACK_COMPLETE_EVENT,
} from '../../playback-constants'
import { animateDemoPlayerAction, wait, waitForDocumentElement } from '../../helpers'

export const playCertificationStep = async ({
  controls,
  fields,
  stepElement,
}: PlayCertificationStepParams) => {
  const fieldsAreTyped = await controls.typeFields(fields)

  if (!fieldsAreTyped) {
    controls.clearFields(fields)
    return false
  }

  const action = stepElement.querySelector<HTMLElement>(
    '[data-demo-playback-action="save-certification"]',
  )

  if (!action) {
    return false
  }

  controls.setActiveFieldElement(null)

  if (!stepElement.closest('.demo-player')) {
    await wait(DEMO_STEP_DELAY)
  }

  await animateDemoPlayerAction({ action, isCancelled: controls.isCancelled })
  action.click()

  if (!stepElement.closest('.demo-player')) {
    const nextStepAction = await waitForDocumentElement(
      '[data-demo-playback-action="banking_commissions"]',
      controls.isCancelled,
    )

    if (!nextStepAction) {
      return false
    }
  }

  return controls.dispatchEvent(new CustomEvent(DEMO_STEP_PLAYBACK_COMPLETE_EVENT, {
    detail: { step: DEMO_CALCULATOR_STEP.CERTIFICATION },
  }))
}
